module.exports = __webpack_public_path__ + "img/loading3.e80db42c.gif";